import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-help",
  "use": "icon-help-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"icon-help\">\n<g transform=\"translate(240 240)\">\n\t<path fill=\"#FFFFFF\" d=\"M-222.821-239.179c0.634,0.633,0.632,1.661,0,2.295l-0.765,0.764l-2.295-2.294l0.764-0.764\n\t\tC-224.483-239.812-223.455-239.813-222.821-239.179z M-234.294-229.999l-0.765,3.058l3.059-0.765l7.648-7.649l-2.295-2.295\n\t\tL-234.294-229.999z M-226.674-231.503v6.994h-10.816v-10.817h6.993l2.163-2.163h-11.318v15.145h15.143v-11.322L-226.674-231.503z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol